import type { ImgHTMLAttributes } from 'react'

type LifestyleImageKey = 'goals' | 'lifeContext' | 'safety' | 'wellness'

export const LIFESTYLE_IMAGES: Record<LifestyleImageKey, { src: string; alt: string }> = {
  goals: {
    src: '/img/not-alone.webp',
    alt: 'Wellness lifestyle visual',
  },
  lifeContext: {
    src: '/img/women-bg.webp',
    alt: 'Life context visual',
  },
  safety: {
    src: '/img/understanding-your-symptoms.webp',
    alt: 'Safety screening visual',
  },
  wellness: {
    src: '/img/jennie.webp',
    alt: 'Wellness journey visual',
  },
}

interface LifestyleImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  src: string
  alt: string
  size?: 'sm' | 'md' | 'hero'
  aspectRatio?: 'wide' | 'standard'
  gradient?: boolean
}

export function LifestyleImage({
  src,
  alt,
  size = 'md',
  aspectRatio = 'wide',
  gradient = false,
  className = '',
  ...imgProps
}: LifestyleImageProps) {
  const sizeClass =
    size === 'sm' ? 'h-[140px]' : size === 'hero' ? 'h-[280px]' : 'h-[200px]'
  const ratioClass = aspectRatio === 'standard' ? 'aspect-[4/5]' : 'aspect-[16/9]'

  return (
    <div className={`relative w-full overflow-hidden rounded-2xl ${sizeClass} ${ratioClass}`}>
      <img
        src={src}
        alt={alt}
        className={`h-full w-full object-cover ${className}`}
        {...imgProps}
      />
      {gradient && (
        <div className='absolute inset-0 bg-gradient-to-t from-[var(--bg-color)]/80 via-transparent to-transparent' />
      )}
    </div>
  )
}
